import { ValidatedTextInputField } from 'common';
import React from 'react';
import { UserFormInput, UserFormInputCommonProps } from '../types';
import { userInputValidationRules } from '../../../domain/validationRules';

export const LastNameInput = (passthroughsProps: UserFormInputCommonProps) => {
    return (<ValidatedTextInputField<UserFormInput>
        {...passthroughsProps}
        name='lastName'
        label={<span className='text-base font-normal'>Last Name</span>}
        placeholder='Doe'
        maxLength={userInputValidationRules.maxLength.value}
        onBlur={e => e.target.value = e.target.value.trim()}
        validationRules={userInputValidationRules}
    />);
}
